import { fromJS } from 'immutable';
import { endLoad, startLoad } from 'portaltransparencia-common/crud/Core.js';

import * as types from './Types.js';

const initialState = fromJS({
  enviados: [],
  recebidos: [],
  repassesMes: [],
  filtros: []
});

function repasseReducer(state = initialState, action) {
  switch (action.type) {
    case types.REPASSES_ENVIADOS_START:
    case types.REPASSES_RECEBIDOS_START:
    case types.REPASSES_MES_START: {
      return startLoad(state);
    }

    case types.REPASSES_ENVIADOS_ERROR:
    case types.REPASSES_RECEBIDOS_ERROR:
    case types.REPASSES_MES_ERROR: {
      return endLoad(state);
    }

    case types.REPASSES_ENVIADOS_SUCCESS: {
      return endLoad(state.set('enviados', fromJS(action.payload)));
    }
    case types.REPASSES_RECEBIDOS_SUCCESS: {
      return endLoad(state.set('recebidos', fromJS(action.payload)));
    }
    case types.REPASSES_MES_SUCCESS: {
      return endLoad(state.set('repassesMes', fromJS(action.payload)));
    }
  }

  return state;
}

export default repasseReducer;
